export default __webpack_public_path__ + "static/media/paralysis.3ede8931.png";